export default __webpack_public_path__ + "img/Arrow.5d5af203.png";